// import { createMuiTheme } from "@material-ui/core/styles"
import { unstable_createMuiStrictModeTheme as createMuiTheme } from "@material-ui/core"

const theme = createMuiTheme({
  palette: {
    background: {
      default: "#F5F1ED",
    },
    primary: {
      contrastText: "#fff",
      dark: "#31125b",
      light: "#6b479b",
      main: "#471A82",
    },
    secondary: {
      contrastText: "#fff",
      dark: "#7e2a4d",
      light: "#c3638b",
      main: "#B53D6E",
    },
    text: {
      disabled: "rgba(0, 0, 0, 0.38)",
      heading: "#373A3C",
      hint: "rgba(0, 0, 0, 0.38)",
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.65)",
    },
  },
  typography: {
    h1: {
      fontSize: "1.5rem",
    },
    h2: {
      fontSize: "1.25rem",
      fontWeight: 900,
    },
    h3: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    h4: {
      fontSize: "0.875rem",
      textTransform: "uppercase",
    },
  },
  overrides: {
    // MuiListItem: {
    //   root: {
    //     "&$selected": {
    //       fontSize: "100px"
    //     }
    //   }
    // },
    MuiSvgIcon: {
      root: {
        color: "currentColor",
      },
    },
    MuiAccordionDetails: {
      root: {
        padding: 0,
      },
    },
    MuiTab: {
      root: {
        minWidth: "32px !important",
      },
    },
  },
})

export default theme
